/** Monotonic mapping from the existing server Unix snapshots onto the renderer clock. */
export class NPCPresentationClock {
  private anchorServer: number | null = null;
  private anchorLocal = 0;
  private lastServerSnapshot = 0;
  private lastSample = 0;
  sample(localMs: number, snapshotServerMs?: number): number {
    const valid = snapshotServerMs !== undefined && Number.isFinite(snapshotServerMs) && snapshotServerMs > 0;
    const projected = this.anchorServer === null ? null : this.anchorServer + Math.max(0, localMs - this.anchorLocal);
    if (valid && snapshotServerMs! > this.lastServerSnapshot) {
      if (this.anchorServer === null) this.lastSample = snapshotServerMs!;
      this.anchorServer = Math.max(projected ?? snapshotServerMs!, snapshotServerMs!);
      this.anchorLocal = localMs;
      this.lastServerSnapshot = snapshotServerMs!;
    }
    // The only wall-clock fallback is an unconnected/editor preview without server snapshots.
    const candidate = this.anchorServer === null ? Date.now() : this.anchorServer + Math.max(0, localMs - this.anchorLocal);
    this.lastSample = this.lastServerSnapshot ? Math.max(this.lastSample, candidate) : candidate;
    return this.lastSample;
  }
}
